import React from 'react'
import { ReactComponent as BackIcon } from 'assets/icons/leftarrowicon.svg'
import { HeaderTheme } from 'utils/types/appTypes'
import './membershipHeader.scss'

interface Props {
  backToFunction?: () => void
  theme?: HeaderTheme
  headerText?: string
}

const MembershipHeader = ({
  backToFunction,
  theme,
  headerText = 'Membership Sign Up',
}: Props) => {
  return (
    <div
      className={`title-box1 ${
        theme &&
        theme === HeaderTheme.NEUTRAL_TERTIARY &&
        'neutral-tertiary-background'
      }
      ${theme && theme === HeaderTheme.GREEN && 'green-background'}
      `}
    >
      <div className="upper-main-header">
        {backToFunction && (
          <div className="back-box">
            <BackIcon className="back-icon" onClick={backToFunction} />
          </div>
        )}
        <span className="header-text">{headerText}</span>
      </div>
    </div>
  )
}

export default React.memo(MembershipHeader)
